import { ExceptionCodes } from '@shared/types/exceptions';

import Exception from './exception';

const dispatchException = (code: string, reason?: string): void => {
  throw getException(code, reason);
};

const getException = (code: string, reason?: string): Exception => {
  return new Exception(code, ExceptionCodes[code], reason);
};

export { dispatchException, getException };
